export const ONLY_EXCEL =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
export const ONLY_CSV = 'text/csv';
